<template>
  <div class="app" id="closed-wave">
    <div class="closed-wave-section d-flex justify-center align-center mt-16">
      <center>
        <!-- <h1 class="mb-3">Gelombang Pendaftaran Telah Ditutup</h1>
        <p>Silakan tunggu gelombang pendaftaran berikutnya dibuka</p> -->
        <div v-if="!closed">
          <h1 class="mb-3">Pendaftaran Belum Dimulai</h1>
          <p>Silakan tunggu informasi selanjutnya</p>
        </div>

        <div v-else>
          <h1 class="mb-3">Pendaftaran Telah Ditutup</h1>
          <p>Silakan tunggu pendaftaran berikutnya</p>
        </div>
      </center>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { EventBus } from "../../event-bus";
import axios from "axios";

export default {
  name: "ClosedWaveSection",
  data: () => ({
    closed: "",
    nextOpen: "",
  }),
  methods: {
    formattedDate(date) {
      moment.locale("id");
      return date ? moment(date).format("Do MMMM YYYY") : "";
    },
    async checkTime() {
      moment.locale("id");

      // Cek jika tanggal sekarang dan tanggal open berjarak 1 minggu
      const resDate = await axios.get(`${this.$api}/get-date`);
      var date = resDate.data.PAYLOAD;
      const currentTime = moment(date);
      var wave = 99;
      if (
        currentTime.isBefore(this.$date[0].open) &&
        currentTime.isBefore(this.$date[0].close)
      ) {
        wave = 0;
      } else if (
        currentTime.isBefore(this.$date[1].open) &&
        currentTime.isBefore(this.$date[1].close)
      ) {
        wave = 1;
      } else if (
        currentTime.isBefore(this.$date[2].open) &&
        currentTime.isBefore(this.$date[2].close)
      ) {
        wave = 2;
      } else if (
        currentTime.isBefore(this.$date[3].open) &&
        currentTime.isBefore(this.$date[3].close)
      ) {
        wave = 3;
      }
      if (wave != 99) {
        var A_WEEK_OLD = moment(this.$date[wave].open)
          .clone()
          .subtract(7, "days")
          .startOf("day");
        if (
          currentTime.isAfter(A_WEEK_OLD) &&
          currentTime.isBefore(this.$date[wave].close)
        ) {
          this.closed = false;
          return (this.nextOpen = this.formattedDate(this.$date[wave].open));
        } else if (currentTime.isAfter(this.$date[wave].close))
          return (this.closed = true);
        else return (this.closed = true);
      } else {
        return (this.closed = true);
      }
    },
  },
  async mounted() {
    EventBus.$emit("startLoading");
    await this.checkTime();
    EventBus.$emit("stopLoading");
  },
};
</script>
